import {AssetPartLayout} from './kmsKilnInfo.types'

export type KilnShellLayout = AssetPartLayout

export type AssetPartLocation = {
  id: string
  label: string
  locationNumber: number
  x: number
  y: number
}

export interface CustomPreviewProps {
  x: number
  y: number
  width: number
  height: number
  meterToPixel?: number
  kilnLength?: number
}

export enum RollerParts {
  SUPPORT_ROLLER_BEARING_LEFT = 'support-roller_bearing-left',
  SUPPORT_ROLLER_DEFLECTOR = 'support-roller_deflector',
  SUPPORT_ROLLER_BEARING_RIGHT = 'support-roller_bearing-right',
  SUPPORT_ROLLER_ROLLER = 'support-roller_roller'
}

export enum StationParts {
  SUPPORT_ROLLER_TOP = 'top',
  SUPPORT_ROLLER_BOTTOM = 'bottom',
  TYRE = 'tyre',
  THRUST_ROLLER = 'thrust-roller'
}
